import { apiCall } from './generated/gqlClient';

const getCustomersApiRequest = async (notArchived, active, isApproved) => {
  const query = `
    query getCustomers($notArchived: Boolean, $active: Boolean, $isApproved: Boolean) {
      getCustomers(notArchived: $notArchived, active: $active, isApproved: $isApproved) {
        id
        customerId
        name
        firstname
        lastname
        gender
        birthday
        address
        city
        postcode
        country
        tags
        url
        facebook
        phone
        email
        role
        describedName
        note
        svcGroupId
        active
        timezone
        nextEventAt
        nextEventName
        membershipActive
        membershipExpiresAt
        groups {
          id
          name
          color
        }
      }
    }
  `;
  return apiCall({ query, variables: { notArchived, active, isApproved } });
};

export { getCustomersApiRequest };
